// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sc1Xn","colMin":"styles_colMin__1JiKh"};